import { OilFieldDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as OilFieldActions from './oil-field.actions';

export const OIL_FIELD_FEATURE_KEY = 'oilfield';

export interface OilFieldState extends EntityState<OilFieldDto> {
  selectedOilFieldId?: string | number; // which OilField record has been selected
  loaded: boolean; // has the OilField list been loaded
  error?: string | null; // last none error (if any)
}

export interface OilFieldPartialState {
  readonly [OIL_FIELD_FEATURE_KEY]: OilFieldState;
}

export const oilFieldAdapter: EntityAdapter<OilFieldDto> = createEntityAdapter<
  OilFieldDto
>({
  selectId: (oilField) => oilField.id,
  sortComparer: false,
});

export const initialState: OilFieldState = oilFieldAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  error: null,
  selectedOilFieldId: null,
});

const oilFieldReducer = createReducer(
  initialState,
  on(OilFieldActions.loadOilField, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(OilFieldActions.loadOilFieldSuccess, (state, { oilField }) =>
    oilFieldAdapter.addAll(oilField, { ...state, loaded: false })
  ),
  on(OilFieldActions.loadOilFieldFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(OilFieldActions.addOilField, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(OilFieldActions.addOilFieldSuccess, (state, { newOilField }) =>
    oilFieldAdapter.addMany(newOilField, { ...state, loaded: false })
  ),
  on(OilFieldActions.addOilFieldFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(OilFieldActions.updateOilField, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(OilFieldActions.updateOilFieldSuccess, (state, { updateOilField }) =>
    oilFieldAdapter.upsertMany(updateOilField, { ...state, loaded: false })
  ),
  on(OilFieldActions.updateOilFieldFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(OilFieldActions.removeOilField, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(OilFieldActions.removeOilFieldSuccess, (state, { ids }) =>
    oilFieldAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(OilFieldActions.removeOilFieldFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(state: OilFieldState | undefined, action: Action) {
  return oilFieldReducer(state, action);
}
